module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/catch-aac2225a34178d20f6a029cd9c539000.png";